import React, { useState, useEffect } from "react";
import { fetchReviews, addReview, editReview, deleteReview } from "../../functions/Reviews";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({
    name: "",
    rating: "",
    comment: "",
    link: ""
  });
  const [message, setMessage] = useState("");
  const [editIdx, setEditIdx] = useState(null);

  useEffect(() => {
    const loadReviews = async () => {
      try {
        const reviewsArr = await fetchReviews();
        setReviews(reviewsArr);
      } catch (err) {
        // console.error("Error fetching reviews:", err);
        setReviews([]);
      }
    };
    loadReviews();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleEditClick = (idx) => {
    setEditIdx(idx);
    setForm({
      name: reviews[idx].name,
      rating: reviews[idx].rating,
      comment: reviews[idx].comment,
      link: reviews[idx].link,
      date: reviews[idx].date,
    });
  };

  const handleEditCancel = () => {
    setEditIdx(null);
    setForm({ name: "", rating: "", comment: "", link: "" });
  };

  const handleEditSave = async (e) => {
    e.preventDefault();
    if (!form.name || !form.rating || !form.comment || !form.link) {
      setMessage("Please fill all required fields.");
      return;
    }
    const updatedReview = {
      ...form,
      date: form.date || new Date().toLocaleDateString(),
    };
    try {
      await editReview(reviews[editIdx]._id, updatedReview);
      setReviews(prev =>
        prev.map((r, i) =>
          i === editIdx ? { ...updatedReview, _id: r._id } : r
        )
      );
      setEditIdx(null);
      setForm({ name: "", rating: "", comment: "", link: "" });
      setMessage("Review updated!");
      setTimeout(() => setMessage(""), 2000);
    } catch (err) {
      setMessage("Error updating review.");
      setTimeout(() => setMessage(""), 2000);
    }
  };

  const handleDelete = async (idx) => {
    const id = reviews[idx]._id;
    if (!window.confirm("Delete this review?")) return;
    try {
      await deleteReview(id);
      setReviews(prev => prev.filter((_, i) => i !== idx));
      setMessage("Review deleted!");
      setTimeout(() => setMessage(""), 2000);
    } catch (err) {
      setMessage("Error deleting review.");
      setTimeout(() => setMessage(""), 2000);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.rating || !form.comment || !form.link) {
      setMessage("Please fill all required fields.");
      return;
    }
    const review = {
      ...form,
      date: new Date().toLocaleDateString()
    };
    try {
      const id = await addReview(review);
      setReviews(prev => [
        ...prev,
        { ...review, _id: id }
      ]);
      setForm({ name: "", rating: "", comment: "", link: "" });
      setMessage("Review added!");
      setTimeout(() => setMessage(""), 2000);
    } catch (err) {
      setMessage("Error adding review.");
      setTimeout(() => setMessage(""), 2000);
    }
  };

  return (
    <div className="reviews-section fadeIn">
      <style>
        {`
          ::placeholder { color: #fff !important; opacity: 0.5 !important; }
          :-ms-input-placeholder { color: #fff !important; opacity: 0.5 !important; }
          ::-ms-input-placeholder { color: #fff !important; opacity: 0.5 !important; }
          select.form-select:invalid { color: #fff; opacity: 0.5; }
          select.form-select option[value=""] { color: #fff; opacity: 0.5; }
          select.form-select { background-color: #000 !important; }
        `}
      </style>
      <div className="admin-card">
        <div className="card-header">
          <h3>Manage Reviews</h3>
        </div>
        <div className="card-body">
          <form className="mb-4" onSubmit={editIdx !== null ? handleEditSave : handleSubmit}>
            <h5>{editIdx !== null ? "Edit Review" : "Add a Review"}</h5>
            {message && <div className="alert alert-info py-1 px-2">{message}</div>}
            <div className="row">
              <div className="col-md-3 mb-2">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Reviewer Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  style={{ color: "#fff" }}
                />
              </div>
              <div className="col-md-3 mb-2">
                <input
                  type="text"
                  className="form-control"
                  name="link"
                  placeholder="Review Link"
                  value={form.link}
                  onChange={handleChange}
                  required
                  style={{ color: "#fff" }}
                />
              </div>
              <div className="col-md-2 mb-2">
                <select
                  className="form-select"
                  name="rating"
                  value={form.rating}
                  onChange={handleChange}
                  required
                  style={{ color: form.rating ? "#fff" : "#fff", backgroundColor: "#000" }}
                >
                  <option value="" disabled>Rating</option>
                  <option value="5">5 ★</option>
                  <option value="4.5">4.5 ★</option>
                  <option value="4">4 ★</option>
                  <option value="3.5">3.5 ★</option>
                  <option value="3">3 ★</option>
                  <option value="2.5">2.5 ★</option>
                  <option value="2">2 ★</option>
                  <option value="1.5">1.5 ★</option>
                  <option value="1">1 ★</option>
                  <option value="0.5">0.5 ★</option>
                </select>
              </div>
              <div className="col-md-4 mb-2">
                <input
                  type="text"
                  className="form-control"
                  name="comment"
                  placeholder="Comment"
                  value={form.comment}
                  onChange={handleChange}
                  required
                  style={{ color: "#fff" }}
                />
              </div>
            </div>
            {editIdx !== null ? (
              <>
                <button type="submit" className="btn btn-success btn-sm mt-2 me-2">
                  <i className="fas fa-save me-1"></i>Save
                </button>
                <button type="button" className="btn btn-secondary btn-sm mt-2" onClick={handleEditCancel}>
                  Cancel
                </button>
              </>
            ) : (
              <button type="submit" className="btn btn-primary btn-sm mt-2">
                <i className="fas fa-plus me-1"></i>Add Review
              </button>
            )}
          </form>
          <hr />
          <h5>All Reviews</h5>
          {reviews.length === 0 ? (
            <div className="alert alert-light">No reviews yet.</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Review Link</th>
                    <th>Rating</th>
                    <th>Comment</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {reviews.map((r, idx) => (
                    <tr key={r._id || idx}>
                      <td>{r.name}</td>
                      <td>
                        {r.link ? (
                          <a href={r.link} target="_blank" rel="noopener noreferrer">{r.link}</a>
                        ) : ""}
                      </td>
                      <td>{r.rating} ★</td>
                      <td>{r.comment}</td>
                      <td>
                        <button
                          className="btn btn-warning btn-sm me-1"
                          onClick={() => handleEditClick(idx)}
                          disabled={editIdx !== null}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(idx)}
                          disabled={editIdx !== null}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
